export default __webpack_public_path__ + "assets/api-unhealthy-f932a4daae6e723990730b1ef3d9491b.svg";